export function templateProcessor(data, string) {
	return string.split(" ").reduce((p, c) => {
		if (/{{(.*?)}}/g.test(c)) {
			const key = c.slice(2, c.length - 2);
			return p + data[key] + " ";
		} else return p + c + " ";
	}, "");
}
